/* Bokja PDP behaviour, loaded globally from layout/theme.liquid so it is present on every
   page (including non-PDP) and therefore ALIVE on PDPs reached via the client-side swap
   (bokja-product-swap), where Horizon's per-page {% javascript %} bundle is NOT loaded.
   Each section below is the verbatim former {% javascript %} block of its snippet (audit T1).
   All three are self-guarded IIFEs (window.__bokja*Bound) using document-level delegation,
   so a single global load is safe (no double-init) and covers swapped-in content. */

/* ===================== strip Shopify recommendation tracking params from the address bar ====== */
(function () {
  if (window.__bokjaUrlCleanBound) return;
  window.__bokjaUrlCleanBound = true;
  // Shopify's product-recommendations API stamps pr_* attribution params (pr_prod_strat, pr_rec_id,
  // pr_rec_pid, pr_ref_pid, pr_seq) onto "You may also adore" links, so a FULL navigation from one
  // lands on a product with a long ugly URL. (Swap navigations are cleaned at source in
  // bokja-product-swap's targetUrl.) The server already logged the recommendation click, so removing
  // them client-side keeps attribution intact and just tidies the bar. Runs on initial load only,
  // which is exactly when a full-nav landing happens.
  try {
    var u = new URL(window.location.href);
    var prKeys = [];
    u.searchParams.forEach(function (v, k) { if (k.indexOf('pr_') === 0) prKeys.push(k); });
    if (prKeys.length) {
      for (var i = 0; i < prKeys.length; i++) u.searchParams.delete(prKeys[i]);
      var qs = u.searchParams.toString();
      history.replaceState(history.state, '', u.pathname + (qs ? '?' + qs : '') + u.hash);
    }
  } catch (e) {}
})();

/* ===================== from snippets/bokja-product-media-stack.liquid ===================== */
(function () {
    if (window.__bokjaMediaSelectBound) return;
    window.__bokjaMediaSelectBound = true;

    function announce(text) {
      var s = document.querySelector('[data-bokja-media-status]');
      if (s && text) s.textContent = text;
    }

    function promote(frame) {
      var stack = frame.closest('[data-bokja-product-media-stack]');
      if (!stack || frame.hasAttribute('data-bokja-hero')) return;
      // Mobile is the native swipe carousel: never swap the hero there. The select buttons
      // are display:none on mobile so a real tap can't reach this anyway; this is belt-and-braces.
      if (window.matchMedia && window.matchMedia('(max-width: 989px)').matches) return;

      // The hero frame is FIXED in the big slot (it holds the dimensions overlay and the DOM
      // order the carousel relies on). Clicking a thumbnail SWAPS its image into the hero <img>
      // — we never move the hero marker, which would otherwise pull a thumbnail out of its
      // scroll column.
      var heroFrame = stack.querySelector('.bokja-product-media-stack__frame[data-bokja-hero]');
      if (!heroFrame || heroFrame === frame) return;
      var heroImg = heroFrame.querySelector('.bokja-product-media-stack__image');
      var thumbImg = frame.querySelector('.bokja-product-media-stack__image');
      if (!heroImg || !thumbImg) return;

      // Close any open dimensions overlay before the hero image changes.
      var open = stack.querySelectorAll('.bokja-product-media-stack__frame.is-dim-open');
      for (var i = 0; i < open.length; i++) {
        open[i].classList.remove('is-dim-open');
        var t = open[i].querySelector('[data-bokja-dim-toggle]');
        if (t) t.setAttribute('aria-pressed', 'false');
      }

      // Show the clicked image big, at hero weight; re-fade it in as the bigger source decodes.
      var full = thumbImg.dataset.full || thumbImg.currentSrc || thumbImg.src;
      heroImg.classList.remove('is-loaded');
      heroImg.classList.remove('is-zoomed');
      zoomedImg = null;
      heroImg.style.transformOrigin = '';
      heroImg.removeAttribute('srcset');
      heroImg.removeAttribute('sizes');
      if (thumbImg.alt) heroImg.alt = thumbImg.alt;
      heroImg.src = full;

      // Dimensions never belong on a close-up (James, 05-08): the lines anchor to the
      // full-product silhouette and cannot line up on a detail crop. Flag the hero frame
      // when a close-up is swapped in; CSS hides the toggle + overlay under the flag.
      var isCloseup = /close/i.test(full) || /close/i.test(thumbImg.alt || '');
      heroFrame.classList.toggle('is-closeup-hero', isCloseup);

      // Mark the active thumbnail.
      var act = stack.querySelectorAll('.bokja-product-media-stack__frame.is-active');
      for (var k = 0; k < act.length; k++) act[k].classList.remove('is-active');
      frame.classList.add('is-active');

      // The hero image changed: re-run the white-background detection + dimensions overlay.
      if (typeof window.__bokjaDimRefresh === 'function') { try { window.__bokjaDimRefresh(); } catch (e) {} }
      window.dispatchEvent(new Event('resize'));

      var btn = frame.querySelector('[data-bokja-media-select]');
      if (btn) announce(btn.getAttribute('aria-label'));
    }

    // Warm the hero-weight source on intent (hover / focus) so the click lands crisp.
    function preload(btn) {
      var frame = btn.closest('.bokja-product-media-stack__frame');
      var img = frame && frame.querySelector('.bokja-product-media-stack__image');
      if (!img || !img.dataset.full || img.dataset.warmed) return;
      if (img.src === img.dataset.full) return;   // hero already at full weight; nothing to warm
      img.dataset.warmed = '1';
      var pre = new Image();
      pre.src = img.dataset.full;
    }

    // --- Inspect zoom (desktop): magnify the hero at a point, then pan with the cursor ---
    var ZOOM_FRAME = '.bokja-product-media-stack__frame';
    var zoomedImg = null;

    // transform-origin resolves against the image's UNSCALED box, which equals the frame box
    // (object-fit:cover fills it). The frame never scales, so its rect is the stable reference
    // for both the opening click and every pan move.
    function setHeroOrigin(img, ev) {
      var frame = img.closest(ZOOM_FRAME) || img;
      var r = frame.getBoundingClientRect();
      if (!r.width || !r.height) return;
      var ox = ((ev.clientX - r.left) / r.width) * 100;
      var oy = ((ev.clientY - r.top) / r.height) * 100;
      img.style.transformOrigin = Math.max(0, Math.min(100, ox)) + '% ' + Math.max(0, Math.min(100, oy)) + '%';
    }
    function exitZoom() {
      var img = zoomedImg || document.querySelector('.bokja-product-media-stack__image.is-zoomed');
      if (img) img.classList.remove('is-zoomed');
      zoomedImg = null;
    }

    document.addEventListener('click', function (event) {
      // Swipe-arrow tap (mobile carousel): advance the viewport by one slide.
      var arrow = event.target.closest && event.target.closest('[data-bokja-stack-arrow]');
      if (arrow) {
        event.preventDefault();
        var stack = arrow.closest('[data-bokja-product-media-stack]');
        var scroller = stack && stack.querySelector('[data-bokja-stack-viewport]');
        if (scroller) {
          var fr = scroller.querySelectorAll('.bokja-product-media-stack__frame');
          if (fr.length > 1) {
            var fw = fr[0].getBoundingClientRect().width || scroller.clientWidth;
            var d = arrow.getAttribute('data-bokja-stack-arrow') === 'prev' ? -1 : 1;
            if (document.documentElement.getAttribute('dir') === 'rtl') d = -d;
            scroller.scrollBy({ left: d * fw, behavior: 'smooth' });
          }
        }
        return;
      }
      // Thumbnail select (desktop): swap it into the hero.
      var btn = event.target.closest && event.target.closest('[data-bokja-media-select]');
      if (btn) {
        event.preventDefault();
        var frame = btn.closest('.bokja-product-media-stack__frame');
        if (frame) promote(frame);
        return;
      }
      // Second click on the ALREADY-active hero image: toggle inspect zoom (desktop only).
      var heroImg = event.target.closest && event.target.closest('.bokja-product-media-stack__frame[data-bokja-hero] .bokja-product-media-stack__image');
      if (!heroImg) {
        exitZoom();   // click away exits zoom
        return;
      }
      if (window.matchMedia && window.matchMedia('(max-width: 989px)').matches) return;   // native pinch on phones
      if (heroImg.classList.contains('is-zoomed')) {
        exitZoom();
      } else {
        setHeroOrigin(heroImg, event);
        heroImg.classList.add('is-zoomed');
        zoomedImg = heroImg;
      }
    });
    // Pan the magnified hero by following the cursor: the point under the pointer stays put, so
    // moving the mouse scrolls around the enlarged image (Arket-style). Only works while a hero is
    // zoomed; outside the frame the origin holds at the last edge so it never snaps back.
    document.addEventListener('pointermove', function (event) {
      if (!zoomedImg) return;
      var frame = zoomedImg.closest(ZOOM_FRAME);
      if (!frame) return;
      var r = frame.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right ||
          event.clientY < r.top || event.clientY > r.bottom) return;
      setHeroOrigin(zoomedImg, event);
    });
    // Escape exits an open zoom.
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      exitZoom();
    });

    document.addEventListener('pointerover', function (event) {
      var btn = event.target.closest && event.target.closest('[data-bokja-media-select]');
      if (btn) preload(btn);
    });
    document.addEventListener('focusin', function (event) {
      var btn = event.target.closest && event.target.closest('[data-bokja-media-select]');
      if (btn) preload(btn);
    });

    // --- Elegant image load: fade the photo into its already-reserved box ---
    function markLoaded(img) {
      if (img && img.classList && !img.classList.contains('is-loaded')) img.classList.add('is-loaded');
    }
    function sweepLoaded(root) {
      var imgs = (root || document).querySelectorAll('.bokja-product-media-stack__image');
      for (var i = 0; i < imgs.length; i++) {
        if (imgs[i].complete && imgs[i].naturalWidth > 0) markLoaded(imgs[i]);
      }
    }

    // Desktop: pin each thumbnail column to its hero's exact height, so exactly three
    // thumbnails show and any others scroll INSIDE the column (seamless, scrollbar hidden)
    // rather than spilling down and pushing the rest of the page. Cleared on phones, where
    // the column dissolves into the swipe carousel.
    function syncThumbColumn() {
      var stacks = document.querySelectorAll('[data-bokja-product-media-stack]');
      for (var s = 0; s < stacks.length; s++) {
        var col = stacks[s].querySelector('.bokja-product-media-stack__thumbs');
        var hero = stacks[s].querySelector('.bokja-product-media-stack__frame[data-bokja-hero]');
        if (!col || !hero) continue;
        if (window.matchMedia && window.matchMedia('(max-width: 989px)').matches) { col.style.height = ''; continue; }
        col.style.height = '';                       // reset to read the natural content height
        var contentH = col.scrollHeight;
        var heroH = Math.round(hero.getBoundingClientRect().height);
        // Cap to the hero (so exactly three show and the rest scroll) ONLY when the thumbnails
        // overflow it; otherwise leave it hugging its content so there is no dead space.
        col.style.height = (heroH > 0 && contentH > heroH + 1) ? heroH + 'px' : '';
      }
    }
    var syncScheduled = false;
    function scheduleSync() {
      if (syncScheduled) return;
      syncScheduled = true;
      var run = function () { syncScheduled = false; syncThumbColumn(); };
      if (window.requestAnimationFrame) { window.requestAnimationFrame(run); } else { setTimeout(run, 0); }
    }
    window.addEventListener('resize', scheduleSync);

    // Exposed so the client-side product swap can reveal freshly-injected media at once: a
    // cached image swapped in via innerHTML fires NO load event, so the per-image listener
    // never sees it, and the first-load safety net does not re-run per swap. Sweeping now and
    // again on the next frame catches images that decode a tick after insertion.
    window.__bokjaRevealMedia = function () {
      sweepLoaded(document);
      requestAnimationFrame(function () { sweepLoaded(document); });
      scheduleSync();
    };
    // load/error don't bubble — capture catches them for current AND swapped-in images.
    function onMediaEvent(e) {
      var t = e.target;
      if (t && t.tagName === 'IMG' && t.classList && t.classList.contains('bokja-product-media-stack__image')) markLoaded(t);
    }
    document.addEventListener('load', onMediaEvent, true);
    document.addEventListener('error', onMediaEvent, true);   // a broken image must never stay invisible
    // Galleries arrive via the client-side swap (innerHTML; no scripts run): mark any
    // already-decoded (cached / prefetched) image at once; the load listener fades in the rest.
    if (window.MutationObserver) {
      new MutationObserver(function (muts) {
        var relevant = false;
        for (var i = 0; i < muts.length; i++) {
          var added = muts[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var n = added[j];
            if (n.nodeType !== 1) continue;
            if (n.matches && n.matches('.bokja-product-media-stack__image')) { if (n.complete && n.naturalWidth > 0) markLoaded(n); }
            else if (n.querySelector) sweepLoaded(n);
            if ((n.matches && n.matches('[data-bokja-product-media-stack]')) || (n.querySelector && n.querySelector('[data-bokja-product-media-stack]'))) relevant = true;
          }
        }
        if (relevant) { sweepLoaded(document); requestAnimationFrame(function () { sweepLoaded(document); }); scheduleSync(); }
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
    // Mark cached images BEFORE enabling the fade (so a decoded hero never flashes to 0),
    // enable, then re-sweep to catch anything decoded between the two calls.
    sweepLoaded(document);
    document.documentElement.classList.add('bokja-media-fade');
    sweepLoaded(document);
    syncThumbColumn();
    scheduleSync();
    if (document.readyState !== 'complete') window.addEventListener('load', scheduleSync);
    setTimeout(syncThumbColumn, 300);   // re-pin once fonts / late layout settle
    // Safety net: a load event missed before the listener bound must not leave a box blank.
    setTimeout(function () {
      var imgs = document.querySelectorAll('.bokja-product-media-stack__image:not(.is-loaded)');
      for (var i = 0; i < imgs.length; i++) { if (imgs[i].complete) markLoaded(imgs[i]); }
    }, 3000);
  })();

/* ===================== from snippets/bokja-product-details.liquid ===================== */
(function () {
    if (window.__bokjaUnitsBound) return;
    window.__bokjaUnitsBound = true;

    // cm is the stored truth (data-bokja-dim-cm). Inches round to the nearest 0.5".
    function fmtNum(cm, unit) {
      if (unit === 'in') {
        var v = Math.round(cm / 2.54 * 2) / 2;
        return (Math.round(v) === v) ? String(Math.round(v)) : String(v);
      }
      return String(Math.round(cm));
    }

    function resolveUnit() {
      try {
        var s = localStorage.getItem('bokja-unit');
        if (s === 'cm' || s === 'in') return s;
      } catch (e) {}
      var t = document.querySelector('[data-bokja-unit-toggle]');
      if (t && t.getAttribute('data-default') === 'in') return 'in';
      return 'cm';
    }

    function apply(unit) {
      var cms = document.querySelectorAll('[data-bokja-dim-cm]');
      for (var i = 0; i < cms.length; i++) {
        var cm = parseFloat(cms[i].getAttribute('data-bokja-dim-cm'));
        if (!isNaN(cm)) cms[i].textContent = fmtNum(cm, unit);
      }
      var us = document.querySelectorAll('[data-bokja-dim-unit]');
      for (var j = 0; j < us.length; j++) us[j].textContent = unit;
      var btns = document.querySelectorAll('[data-bokja-unit-toggle] .bokja-unit-toggle__btn');
      for (var k = 0; k < btns.length; k++) {
        var on = btns[k].getAttribute('data-unit') === unit;
        btns[k].classList.toggle('is-active', on);
        btns[k].setAttribute('aria-pressed', on ? 'true' : 'false');
      }
    }

    document.addEventListener('click', function (event) {
      var btn = event.target.closest && event.target.closest('[data-bokja-unit-toggle] .bokja-unit-toggle__btn');
      if (!btn) return;
      event.preventDefault();
      var unit = btn.getAttribute('data-unit') === 'in' ? 'in' : 'cm';
      try { localStorage.setItem('bokja-unit', unit); } catch (e) {}
      apply(unit);
    });

    // RTW size pills: single-select within a group; sync the hidden Size property.
    document.addEventListener('click', function (event) {
      var pill = event.target.closest && event.target.closest('.bokja-sizes__pill');
      if (!pill) return;
      event.preventDefault();
      if (pill.disabled) return;
      var group = pill.closest('[data-bokja-sizes]');
      if (group) {
        var pills = group.querySelectorAll('.bokja-sizes__pill');
        for (var i = 0; i < pills.length; i++) { pills[i].classList.remove('is-selected'); pills[i].setAttribute('aria-pressed', 'false'); }
      }
      pill.classList.add('is-selected');
      pill.setAttribute('aria-pressed', 'true');
      var aside = pill.closest('.bokja-product-details');
      bokjaApplySizeState(aside, pill);
      bokjaSizeMeasure(aside, pill);
    });

    // ---- PDP stock state machine (client half) -------------------------------------------
    // The server resolved every size to one of three states and stamped it on the pill:
    //   in       buy this variant
    //   alter    buy the NEXT SIZE UP's variant and record the requested size on the line item
    //            (the atelier alters it down - Jalal's ruling, 2026-08-07). Inventory stays
    //            truthful because the unit consumed IS the larger garment; counts are never
    //            pooled across variants. NOTHING about the alteration is shown to the customer
    //            (James, 2026-08-07 night: "just let people buy it") - it travels on the
    //            underscore-prefixed _requested_size property, which Shopify never renders in
    //            cart or checkout but does keep on the order for the atelier.
    //   enquire  nothing larger left - swap the buy block for the WhatsApp request route
    // This only moves what the server already rendered: no state is invented here.
    function bokjaApplySizeState(aside, pill) {
      if (!aside || !pill) return;
      var size = pill.getAttribute('data-bokja-size') || '';
      var state = pill.getAttribute('data-bokja-state') || 'in';
      var vid = pill.getAttribute('data-bokja-variant');

      // Route the cart to the variant that actually serves this size, so the right pair's
      // count is decremented (an L order must not draw down S/M).
      if (vid) {
        var idInput = aside.querySelector('input[name="id"]');
        if (idInput && idInput.value !== vid) idInput.value = vid;
      }

      // Exactly ONE size statement rides on the line item: the visible "Size" normally, the
      // hidden "_requested_size" when the piece is being altered down. A disabled input is not
      // serialised by FormData, so the swap is the toggle and the two can never both post.
      var sizeProp = aside.querySelector('[data-bokja-size-prop]');
      var alterProp = aside.querySelector('[data-bokja-alter-prop]');
      if (sizeProp) {
        sizeProp.value = size;
        sizeProp.disabled = state === 'alter';
      }
      if (alterProp) {
        alterProp.disabled = state !== 'alter';
        alterProp.value = state === 'alter' ? size : '';
      }

      // Scarcity line: the resolved variant holds exactly one tracked unit.
      var scarcity = aside.querySelector('[data-bokja-scarcity]');
      if (scarcity) scarcity.hidden = !(state !== 'enquire' && pill.getAttribute('data-bokja-scarce') === '1');

      // Swap the CTA block.
      var buy = aside.querySelector('[data-bokja-cta="buy"]');
      var enquire = aside.querySelector('[data-bokja-cta="enquire"]');
      if (buy) buy.hidden = state === 'enquire';
      if (enquire) enquire.hidden = state !== 'enquire';

      // Per-size request links: the server baked a __SIZE__ token into the finished hrefs.
      var links = aside.querySelectorAll('[data-bokja-size-href]');
      for (var i = 0; i < links.length; i++) {
        var link = links[i];
        if (!link.getAttribute('data-bokja-href-tpl')) link.setAttribute('data-bokja-href-tpl', link.getAttribute('href') || '');
        var hrefTpl = link.getAttribute('data-bokja-href-tpl') || '';
        link.setAttribute('href', hrefTpl.split('__SIZE__').join(encodeURIComponent(size)));
      }
    }

    function bokjaSizeStateInit() {
      var asides = document.querySelectorAll('.bokja-product-details');
      for (var i = 0; i < asides.length; i++) {
        var group = asides[i].querySelector('[data-bokja-sizes]');
        if (!group) continue;
        var sel = group.querySelector('.bokja-sizes__pill.is-selected') || group.querySelector('.bokja-sizes__pill');
        if (sel) bokjaApplySizeState(asides[i], sel);
      }
    }

    // Surface the selected size's defining body measurement (waist for bottoms, bust otherwise)
    // under the pills, in the visitor's unit. The value + the unit are pre-rendered per pill
    // (data-bokja-measure) by bokja-product-details, so this just mirrors the selected pill in.
    function bokjaSizeMeasure(aside, pill) {
      if (!aside) return;
      var hint = aside.querySelector('[data-bokja-size-measure]');
      if (!hint) return;
      var valEl = hint.querySelector('[data-bokja-measure-value]');
      var val = pill && pill.getAttribute('data-bokja-measure');
      if (val && valEl) { valEl.textContent = val; hint.hidden = false; }
      else { hint.hidden = true; }
    }
    function bokjaSizeMeasureInit() {
      var asides = document.querySelectorAll('.bokja-product-details');
      for (var i = 0; i < asides.length; i++) {
        var sel = asides[i].querySelector('.bokja-sizes__pill.is-selected') || asides[i].querySelector('.bokja-sizes__pill');
        if (sel) bokjaSizeMeasure(asides[i], sel);
      }
    }

    function init() { apply(resolveUnit()); bokjaSizeMeasureInit(); bokjaSizeStateInit(); }
    // Re-apply the stored cm/in preference to content swapped in by the client-side
    // navigation (the swapped HTML always renders the cm defaults), and re-sync the stock
    // state onto the swapped-in markup.
    window.__bokjaUnitsRefresh = function () { apply(resolveUnit()); bokjaSizeMeasureInit(); bokjaSizeStateInit(); };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

/* ===================== from snippets/bokja-dimensions-overlay.liquid ===================== */
(function () {
    if (window.__bokjaDimBound) return;
    window.__bokjaDimBound = true;

    // Photo's rendered rect inside the <img> box (object-fit: contain). Returns the
    // letterboxed content area relative to the frame so the overlay sits on the piece,
    // not the box. With no letterbox this is just the full box.
    function contentRect(img) {
      var ew = img.clientWidth, eh = img.clientHeight;
      var nw = img.naturalWidth, nh = img.naturalHeight;
      if (!ew || !eh || !nw || !nh) return null;
      var ea = ew / eh, na = nw / nh, cw, ch;
      if (na > ea) { cw = ew; ch = ew / na; } else { ch = eh; cw = eh * na; }
      return { left: img.offsetLeft + (ew - cw) / 2, top: img.offsetTop + (eh - ch) / 2, width: cw, height: ch };
    }

    function applyLayout(frame) {
      var dim = frame.querySelector('[data-bokja-dim]');
      var img = frame.querySelector('.bokja-product-media-stack__image');
      var toggle = frame.querySelector('[data-bokja-dim-toggle]');
      if (!dim || !img) return;
      var r = contentRect(img);
      if (!r) return;
      // Snap the overlay box and every bracket coordinate to the DEVICE-pixel grid, and draw the
      // lines as one device-pixel hairline (--dim-hairline). A plain 1px CSS line lands on a
      // different sub-pixel offset per line at fractional devicePixelRatios, so the width line and
      // the height line antialias differently and read as different thicknesses. Snapping puts every
      // line on the same grid so they render identically. (James: "lines still not the same thickness".)
      var dpr = window.devicePixelRatio || 1;
      function snap(v) { return Math.round(v * dpr) / dpr; }
      var L = snap(r.left), T = snap(r.top), W = snap(r.width), H = snap(r.height);
      dim.style.inset = 'auto';
      dim.style.left = L + 'px';
      dim.style.top = T + 'px';
      dim.style.width = W + 'px';
      dim.style.height = H + 'px';
      dim.style.setProperty('--dim-hairline', (Math.max(1, Math.round(dpr)) / dpr) + 'px');
      if (dim.dataset.dimL) {
        dim.style.setProperty('--dim-left', snap(parseFloat(dim.dataset.dimL) * W) + 'px');
        dim.style.setProperty('--dim-right', snap(parseFloat(dim.dataset.dimR) * W) + 'px');
        dim.style.setProperty('--dim-top', snap(parseFloat(dim.dataset.dimT) * H) + 'px');
        dim.style.setProperty('--dim-bottom', snap(parseFloat(dim.dataset.dimB) * H) + 'px');
      }
      // BEGIN room boxes tilt (scripts/push-dim-overlay-room-boxes.js)
      // A room photo's rectangle carries the cushion's tilt: rotate the whole overlay (lines and
      // labels together) about the cushion centre, in the photo's own pixel frame. Cleared on any
      // frame without a tilt so a catalogue shot swapped in after a room photo draws square.
      if (dim.dataset.dimDeg) {
        dim.style.transformOrigin = (parseFloat(dim.dataset.dimCx) * W) + 'px ' + (parseFloat(dim.dataset.dimCy) * H) + 'px';
        dim.style.transform = 'rotate(' + dim.dataset.dimDeg + 'deg)';
      } else {
        dim.style.transform = '';
        dim.style.transformOrigin = '';
      }
      // END room boxes tilt
      if (toggle) {
        // inset-inline-end is a logical edge: under RTL it resolves to the physical
        // LEFT edge, whose gap to the photo is r.left. Feeding the right-edge gap
        // into it would mis-anchor the toggle on letterboxed RTL frames.
        var rtl = getComputedStyle(frame).direction === 'rtl';
        toggle.style.insetInlineEnd = (rtl ? (L + 14) : (frame.clientWidth - (L + W) + 14)) + 'px';
        toggle.style.insetBlockEnd = (frame.clientHeight - (T + H) + 14) + 'px';
      }
    }

    function detect(frame) {
      var dim = frame.querySelector('[data-bokja-dim]');
      var img = frame.querySelector('.bokja-product-media-stack__image');
      if (!dim || !img) return;
      // This JS is alive on this frame -> let the toggle show (CSS keeps it hidden until now, so a
      // product swapped in from a non-product page, where this per-page JS never loaded, has no
      // inert toggle). The art-shot gate below can still hide it again via .bokja-dim-unavailable.
      frame.classList.add('bokja-dim-ready');
      var src = img.currentSrc || img.src;
      if (!src) return;
      // BEGIN room boxes (scripts/push-dim-overlay-room-boxes.js, data/flora-fauna/room-boxes.json)
      // Room / lifestyle photos carry a hand-set cushion rectangle (James, 2026-09-18): the canvas
      // probe cannot find a piece on a furnished backdrop, so it comes from this map, keyed on the
      // Shopify file name (bokja-flora-fauna-<slot>): [centre x, centre y, width, height, tilt deg],
      // fractions of the image; the overlay is rotated by the tilt about the centre in applyLayout.
      var roomBoxes = {
      'ff-1-s2': [0.647, 0.613, 0.477, 0.209, -3.2],
      'ff-1-s5': [0.492, 0.599, 0.490, 0.199, 0.1],
      'ff-1-s6': [0.477, 0.563, 0.457, 0.242, -0.4]
      };
      var roomKey = (src.match(/bokja-flora-fauna-(ff-\d+-s\d+)/) || [])[1];
      var roomBox = roomKey && roomBoxes[roomKey];
      if (roomBox) {
        frame.classList.remove('bokja-dim-unavailable');
        dim.dataset.dimL = (roomBox[0] - roomBox[2] / 2).toFixed(4);
        dim.dataset.dimR = (roomBox[0] + roomBox[2] / 2).toFixed(4);
        dim.dataset.dimT = (roomBox[1] - roomBox[3] / 2).toFixed(4);
        dim.dataset.dimB = (roomBox[1] + roomBox[3] / 2).toFixed(4);
        dim.dataset.dimCx = roomBox[0].toFixed(4);
        dim.dataset.dimCy = roomBox[1].toFixed(4);
        dim.dataset.dimDeg = roomBox[4].toFixed(1);
        if (img.complete && img.naturalWidth) { applyLayout(frame); }
        else { img.addEventListener('load', function () { applyLayout(frame); }, { once: true }); }
        return;
      }
      delete dim.dataset.dimDeg;   // a catalogue shot after a room photo: no tilt
      // END room boxes
      var probe = new Image();
      probe.crossOrigin = 'anonymous';
      probe.onload = function () {
        try {
          var w = 200;
          var h = Math.max(1, Math.round(w * probe.naturalHeight / probe.naturalWidth));
          var canvas = document.createElement('canvas');
          canvas.width = w;
          canvas.height = h;
          var ctx = canvas.getContext('2d');
          ctx.drawImage(probe, 0, 0, w, h);
          var data = ctx.getImageData(0, 0, w, h).data;
          // Sample the backdrop colour from the four corners. Bokja photos sit on
          // a warm off-white (beige) backdrop, not pure white, so a fixed near-white
          // threshold treated the whole frame as the piece. Find pixels that differ
          // from the measured backdrop instead.
          function bokjaCorner(x, y) { var k = (y * w + x) * 4; return [data[k], data[k + 1], data[k + 2]]; }
          var corners = [[2, 2], [w - 3, 2], [2, h - 3], [w - 3, h - 3]];
          var br = 0, bgc = 0, bb = 0;
          for (var c = 0; c < corners.length; c++) { var cp = bokjaCorner(corners[c][0], corners[c][1]); br += cp[0]; bgc += cp[1]; bb += cp[2]; }
          br /= 4; bgc /= 4; bb /= 4;
          // The bracket is a clean axis-aligned W x H (x D) measure — it only reads on
          // Bokja's catalogue shots (the piece square-on against a warm, LIGHT backdrop).
          // Art-directed shots (a piece on a dark, dramatic backdrop, often at an angle)
          // can't carry it: detection still finds a silhouette, but the lines land nowhere
          // sensible (e.g. a bench photographed standing vertically). Use the backdrop
          // luminance as the tell — a dark backdrop means an art shot — and hide the overlay
          // there instead of drawing a wrong bracket. The dimensions stay as text in the
          // details column either way.
          var bgLum = 0.2126 * br + 0.7152 * bgc + 0.0722 * bb;
          if (bgLum <= 150) {
            frame.classList.add('bokja-dim-unavailable');
            frame.classList.remove('is-dim-open');
            var togHide = frame.querySelector('[data-bokja-dim-toggle]');
            if (togHide) togHide.setAttribute('aria-pressed', 'false');
          } else {
            frame.classList.remove('bokja-dim-unavailable');
            var minX = w, minY = h, maxX = 0, maxY = 0, count = 0, dist2 = 44 * 44;
            for (var y = 0; y < h; y++) {
              for (var x = 0; x < w; x++) {
                var i = (y * w + x) * 4;
                if (data[i + 3] <= 20) continue;
                var dr = data[i] - br, dg = data[i + 1] - bgc, db = data[i + 2] - bb;
                if (dr * dr + dg * dg + db * db > dist2) {
                  count++;
                  if (x < minX) minX = x;
                  if (x > maxX) maxX = x;
                  if (y < minY) minY = y;
                  if (y > maxY) maxY = y;
                }
              }
            }
            // Trust the detection only when it found a sensible region: not empty, and
            // not nearly the whole frame (which means it failed). Otherwise keep the
            // CSS fallback insets so the lines still sit reasonably around the piece.
            var fracW = (maxX - minX) / w, fracH = (maxY - minY) / h;
            if (count > 50 && fracW > 0.05 && fracW < 0.96 && fracH > 0.05 && fracH < 0.96) {
              // Store the piece bounds as FRACTIONS; applyLayout converts them to device-pixel-snapped
              // px every time it runs (load + resize) so the lines stay crisp + identical at any size.
              dim.dataset.dimL = (minX / w).toFixed(4);
              dim.dataset.dimR = (maxX / w).toFixed(4);
              dim.dataset.dimT = (minY / h).toFixed(4);
              dim.dataset.dimB = (maxY / h).toFixed(4);
            } else if (fracW >= 0.96 || fracH >= 0.96) {
              // The silhouette spans the frame edge to edge: a room / lifestyle photo on a light
              // wall (the Flora & Fauna room shots, 2026-09-17), not a piece on a backdrop. The
              // generic insets would bracket the whole room, so hide the overlay as for a dark art
              // shot. Calibrated on the 13 room photos (fracW 0.99-1.00) against the six catalogue
              // fronts (fracW 0.64-0.77, fracH 0.40-0.44).
              frame.classList.add('bokja-dim-unavailable');
              frame.classList.remove('is-dim-open');
              var togEdge = frame.querySelector('[data-bokja-dim-toggle]');
              if (togEdge) togEdge.setAttribute('aria-pressed', 'false');
            }
          }
        } catch (e) {
          /* tainted canvas or read error: keep the fallback insets */
        }
        applyLayout(frame);
      };
      probe.src = src;
      if (img.complete && img.naturalWidth) {
        applyLayout(frame);
      } else {
        img.addEventListener('load', function () { applyLayout(frame); }, { once: true });
      }
    }

    function eachFrame(fn) {
      var frames = document.querySelectorAll('.bokja-product-media-stack__frame');
      for (var i = 0; i < frames.length; i++) {
        if (frames[i].querySelector('[data-bokja-dim]')) fn(frames[i]);
      }
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { eachFrame(applyLayout); }, 150);
    });
    window.addEventListener('load', function () { eachFrame(applyLayout); });

    document.addEventListener('click', function (event) {
      var toggle = event.target.closest && event.target.closest('[data-bokja-dim-toggle]');
      if (!toggle) return;
      event.preventDefault();
      var frame = toggle.closest('.bokja-product-media-stack__frame');
      if (!frame) return;
      var open = frame.classList.toggle('is-dim-open');
      toggle.setAttribute('aria-pressed', open ? 'true' : 'false');
    });

    // Re-run detection + layout for product content swapped in by the client-side
    // navigation (bokja-product-swap). The canvas read normally fires once on load;
    // swapped-in frames need it re-run so their brackets lock to the new piece.
    //
    // detect() runs DIRECTLY, not inside requestAnimationFrame: its dark-backdrop
    // canvas probe is already async (it fires on the probe image's own load), so it
    // never needed a frame callback — and rAF is SUSPENDED in background / inactive
    // tabs (and can be deferred under load right at swap time). Gating detection on rAF
    // meant the dark-shot HIDE silently never ran on a backgrounded swap, leaving the
    // overlay showing on art-directed shots with the generic fallback insets. Only
    // applyLayout (which measures the rendered box) waits a frame.
    window.__bokjaDimRefresh = function () {
      eachFrame(function (frame) {
        var img = frame.querySelector('.bokja-product-media-stack__image');
        function run() {
          detect(frame);                                          // async via probe load — runs even when rAF is throttled
          requestAnimationFrame(function () { applyLayout(frame); });
        }
        if (!img || (img.complete && img.naturalWidth)) { run(); }
        else { img.addEventListener('load', run, { once: true }); }
      });
    };

    // A tab hidden during a swap has rAF suspended AND may have skipped the visible
    // detect pass; re-detect when it comes forward so the overlay self-heals.
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') eachFrame(detect);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', eachFrame.bind(null, detect));
    } else {
      eachFrame(detect);
    }
  })();

